import React from 'react';
import { Label, LabelGroup, Skeleton } from '@patternfly/react-core';

export const MultiLabelGroup = ({ labels, maxLabels = 4 }) => {
  return (
    <LabelGroup
      onClick={() => {}}
      numLabels={maxLabels}
    >
      { labels?.map((labelData, index) => (
        <Label key={index}
          variant={labelData.variant ?? 'outline'}
          color={labelData.color ?? 'blue'}
        >
          { labelData.isLoading ? <Skeleton key={index} width="60px" /> : labelData.label }
        </Label>
      )) }
    </LabelGroup>
  );
};

export default React.memo(MultiLabelGroup);
